const faqItems = [
  {
    q: '五一吃瓜网是什么类型的网站？',
    a: '五一吃瓜网是一个专注热门事件追踪与娱乐八卦聚合的一站式资讯平台，汇集娱乐圈热点、网红动态、综艺爆料、影视花边等多维度内容，为瓜友提供快速获取最新吃瓜资讯的便捷入口。',
  },
  {
    q: '如何快速进入五一吃瓜网首页？',
    a: '直接访问五一吃瓜网官方网址即可进入首页。建议将本站加入浏览器收藏夹或设为首页，这样每次打开浏览器都能一键直达五一吃瓜网入口，实时获取最新吃瓜资讯。',
  },
  {
    q: '五一吃瓜网的内容多久更新一次？',
    a: '五一吃瓜网保持全天候实时更新机制，编辑团队 7×24 小时跟踪全网热点，确保重大吃瓜事件第一时间上线。热门事件专题页随进展持续更新，保证瓜友不错过任何关键信息。',
  },
  {
    q: '使用五一吃瓜网需要注册账号吗？',
    a: '不需要。五一吃瓜网所有内容完全免费开放浏览，无需注册登录即可直接访问全部资讯、专题和榜单内容，真正做到打开即看、畅快吃瓜。',
  },
  {
    q: '五一吃瓜网上的信息来源可靠吗？',
    a: '五一吃瓜网内容团队会对热点信息进行多方交叉核实，标注信息来源与可信度。我们坚持客观呈现事件全貌，让瓜友基于全面信息自主判断，同时倡导理性吃瓜、文明讨论。',
  },
  {
    q: '手机上怎么访问五一吃瓜网？',
    a: '五一吃瓜网已全面适配移动端访问，在手机浏览器输入官方地址即可流畅浏览。页面自动适配屏幕尺寸，无论是看专题、刷快讯还是查榜单，手机端体验与桌面端一致出色。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于五一吃瓜网入口、使用方式和内容更新的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-primary-50/30 transition-colors list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line text-lg"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 hidden group-open:flex items-center justify-center text-primary-500">
                  <i className="ri-subtract-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}